import {currentOutputReview,outputIssues} from './deliveryContract.js';
const text=(v,max=4000)=>typeof v==='string'?v.trim().slice(0,max):'';
export function normalizeLocalization(value){
 if(!value||typeof value!=='object')return null;
 return {masterId:text(value.masterId,100),masterRevision:Number.isSafeInteger(value.masterRevision)?value.masterRevision:0,language:text(value.language,100),region:text(value.region,100),changes:Object.fromEntries(['copy','voice','packaging','disclaimers'].map(key=>[key,text(value.changes?.[key])]))};
}
export function localizationIssues(item,c){
 const l=item.localization;if(!l)return [];
 const master=c.content.find(output=>output.id===l.masterId),issues=[];
 if(!master||master.id===item.id||master.localization)issues.push('Choose an original master, not another localization.');
 if(!master||master.revision!==l.masterRevision||!currentOutputReview(master,c)||!['approved','ready'].includes(master.status))issues.push('Localized output is stale: review the current master and reconcile this derivative.');
 if(master&&master.id!==item.id&&!master.localization&&outputIssues(master,c).length)issues.push('The master has unresolved delivery requirements.');
 const d=c.deliverables.find(d=>d.id===item.deliverableId);
 if(!l.language||!l.region||!d||d.language!==l.language||d.region!==l.region)issues.push('Localized output language and region must match its ordered deliverable.');
 if(Object.values(l.changes).some(value=>!value))issues.push('Record changes to copy, voice, packaging and disclaimers; explicitly state unchanged where applicable.');
 return issues;
}
export function bindLocalization(item,c){
 if(!item.localization)return;
 const master=c.content.find(output=>output.id===item.localization.masterId);
 if(master)item.localization.masterRevision=master.revision;
 const issues=localizationIssues(item,c);if(issues.length)throw new Error(issues.join('. '));
}
